<template>
  <q-layout-header class="a-layout-header">
    <q-toolbar class="full-height" color="white">
      <q-btn
        color="black"
        flat
        dense
        round
        aria-label="Menu"
        @click="showDrawer = !showDrawer"
      >
        <q-icon name="menu" />
      </q-btn>
      <q-toolbar-title class="col-auto row items-center">
        <router-link to="/" class="row items-center">
          <img
            height="30"
            :src="$app.logo"
            class="cursor-pointer"
          >
        </router-link>
        <div
          v-small-caps="currentBranch.name"
          class="q-body-2 text-dark uppercase q-ml-md"
          style="word-spacing: 2px;"
        />
      </q-toolbar-title>

      <div class="col flex justify-center q-px-lg" v-if="$store.getters['auth/alSupport']">
        <a-autocomplete-input
          ref="dealerSearch"
          v-model="search"
          :search="fetchDealers"
          clearable
          no-parent-field
          hide-underline
          :min-characters="0"
          :max-results="20"
          :debounce="600"
          class="q-body-1 full-width"
          style="max-width: 400px; height: 40px"
          placeholder="Firmenname, Email-Adresse, etc."
          @selected="onDealerSelect"
          @keyup.enter.native="onSearchEnter"
        />
      </div>
      <div v-else class="col" />

      <div
        class="row items-center q-caption text-italic text-faded"
        v-show="mobileDeAd.loading || as24Ad.loading || elnAd.loading"
      >
        <div v-if="mobileDeAd.loading">{{ mobileDeAd.loadingMessage }}</div>
        <span v-if="as24Ad.loading && mobileDeAd.loading" class>, &nbsp;</span>
        <div v-if="as24Ad.loading">{{ as24Ad.loadingMessage }}</div>
        <span v-if="elnAd.loading && (mobileDeAd.loading && !as24Ad.loading || as24Ad.loading)" class>, &nbsp;</span>
        <div v-if="elnAd.loading">{{ elnAd.loadingMessage }}</div>
        <q-spinner color="primary" :size="30" class="q-ml-sm" />
      </div>
      <payment-overdue-hint v-if="showPaymentOverdueHint" />
      <abo-upgrade
        :showRemaining="true"
        v-if="currentDealer.trialPeriodEnd !== null"
      />
      <notification-button />
      <settings-popover />
    </q-toolbar>
  </q-layout-header>
</template>

<script>
import AboUpgrade from '@/components/base/AboUpgrade.vue';
import PaymentOverdueHint from '@/components/base/PaymentOverdueHint.vue';
import SettingsPopover from '@/components/base/SettingsPopover.vue';
import NotificationButton from '@/layouts/layout-components/notification/NotificationButton.vue';

import { mapState, mapActions, mapGetters } from 'vuex';
import { settings } from '@/plugins/mixins';
import { formatName } from '@/plugins/util';

export default {
  components: {
    SettingsPopover,
    AboUpgrade,
    PaymentOverdueHint,
    NotificationButton,
  },
  data() {
    return {
      search: null,
    };
  },
  mixins: [
    settings('userSetting', {
      showDrawer: 'layout.showMiniDrawer',
    }),
  ],
  computed: {
    ...mapState('auth', ['currentDealer', 'currentBranch']),
    ...mapState('ads', ['mobileDeAd', 'as24Ad', 'elnAd']),
    ...mapState('dealerList', ['dealerList']),
    ...mapGetters('auth', ['isDealerOwner', 'isBranchOwner']),
    ...mapGetters('subscription', ['paymentDeadline']),
    showPaymentOverdueHint() {
      return !!this.paymentDeadline && (this.isDealerOwner || this.isBranchOwner);
    },
  },

  methods: {
    ...mapActions('dealerList', ['getDealerList']),
    async fetchDealers(searchTerms, done) {
      this.$store.commit('dealerList/SET_SEARCH', searchTerms);
      await this.getDealerList();
      if (!searchTerms) {
        return done();
      }
      return done(this.preprocessDealer(this.dealerList));
    },
    preprocessDealer(dealerList = []) {
      return dealerList.map(dealer => ({
        label: `${dealer.name}`,
        value: dealer.ID,
        sublabel: `${formatName(dealer)} (${dealer.email})`,
        letter: (dealer.name && dealer.name[0]) || (dealer.email && dealer.email[0]),
      }));
    },
    onDealerSelect(dealerId) {
      if (!dealerId) return;

      this.$store.commit('dealerList/SET_SEARCH', '');
      this.search = null;

      if (+this.$route.params.dealerId === dealerId) return;
      this.$router.push(`/admin/dealer/${dealerId}`);
    },
    onSearchEnter() {
      if (typeof this.search !== 'string' || !this.search.trim()) return;

      this.$refs.dealerSearch.$refs.autocomplete.blur();
      this.$store.commit('dealerList/SET_SEARCH', this.search.trim());
      this.search = null;

      if (this.$route.name === 'adminDealerOverview') {
        this.getDealerList();
        return;
      }
      this.$router.push({ name: 'adminDealerOverview' });
    },
  },

};
</script>

<style scoped lang="stylus">
@import theme

.a-layout-header {
  border-bottom: 1px solid;
  border-color: rgb(228, 231, 236);
  box-shadow: 0px 4px 8px -3px rgba(17, 17, 17, 0.06) !important;
  height: 64px;
}

.filter {
  border: 2px solid $faded;
  border-radius: 4px;
  padding: 5px;
  padding-left: 8px;
}

.hard-center {
  position: absolute;
}
</style>
